import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import LazyImage from '@/components/base/LazyImage'
import Section from '@/components/base/Section'

import Typography from '../base/Typography'
import { SectionTheme, WPImage, WPLink } from '@/types'

type ImageGridProps = SectionTheme & {
  items?: Partial<{
    image: Partial<WPImage>
    overline: string
    link: WPLink
  }>[]
}

const ImageGrid = ({ theme, items = [] }: ImageGridProps) => {
  return (
    <Section theme={theme}>
      <Container>
        <Grid className="gap-y-gutter">
          {items.map(({ image, overline, link }, index) => (
            <div key={`image-${index}`} className="col-span-1 md:col-span-2">
              <a
                href={link?.url}
                target={link?.target}
                className="grid gap-y-spacing-xs"
              >
                <span className="aspect-h-[90] aspect-w-[182] relative block">
                  <LazyImage
                    src={image?.sizes?.large.url || image?.url || ''}
                    alt={image?.alt || ''}
                    fill
                    className="object-cover object-center"
                  />
                </span>
                <Typography
                  variant="overline"
                  className="text-center text-text-primary-light dark:text-text-primary-dark"
                >
                  {overline}
                </Typography>
              </a>
            </div>
          ))}
        </Grid>
      </Container>
    </Section>
  )
}

export default ImageGrid
